export default "__VITE_ASSET__a2b72d3f__"